export class ConfirmSelfAssessedModel {
    selfId: number;
    isSelfAssessed: boolean;

    constructor() {
        this.selfId = 0;
        this.isSelfAssessed = false;
    }
}